import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["removeLink", "fileLink", "removeFileInput"]
  }

  deleteFile(e) {
    e.preventDefault()
    this.removeFileInputTarget.value = "1"
    this.removeLinkTarget.classList.add("hidden")
    this.fileLinkTarget.classList.add("hidden")
  }

  resetRemoveFileInput() {
    if (this.hasRemoveFileInputTarget) {
      this.removeFileInputTarget.value = ""
    }
  }
}
